import React from "react";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import {
  GetUserRosterFilesQuery,
  GetUserRosterFilesQueryVariables,
} from "generated/graphql";

export const useUserRosterTable = () => {
  const [page, setPage] = React.useState(1);
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DATA_EXCHANGE_PER_PAGE!,
    10
  );

  const { data, refetch, loading } = useQuery<
    GetUserRosterFilesQuery,
    GetUserRosterFilesQueryVariables
  >(
    queries.GET_USER_ROSTER_FILES_QUERY,
    {
      variables: {
        page,
        perPage: rowsPerPage,
      },
    }
  );

  const totalCount =
    data && data.batchOnboardFiles && data.batchOnboardFiles.totalCount
      ? data.batchOnboardFiles.totalCount
      : 0;
  const onChangePageFn = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  React.useEffect(() => {
    refetch({ page });
  }, [page, refetch]);

  return {
    loading,
    page,
    rowsPerPage,
    totalCount,
    data,
    onChangePageFn,
  };
};
